import "./App.css";
import { useState, useEffect, useRef } from "react";

const API_URL = "/ultg";

function apiFetch(url, options = {}) {
  const token = localStorage.getItem("ultg_auth_token");
  const headers = { ...(options.headers || {}) };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  return fetch(url, { ...options, headers }).then(res => {
    if (res.status === 401 && token) {
      localStorage.removeItem("ultg_auth_token");
      window.location.reload();
    }
    return res;
  });
}

const STATUS_OPTIONS = [
  { value: "tidak_padam",          label: "🚫 Tidak Padam" },
  { value: "padam_tidak_menginap", label: "🌞 Padam Tidak Menginap" },
  { value: "padam_menginap",       label: "🌙 Padam Menginap" },
];
const PROGRESS_OPTIONS = [
  { value: "belum",        label: "🔴 Belum Dimulai", symbol: "🔴" },
  { value: "progress",     label: "⏳ On Progress",   symbol: "⏳" },
  { value: "selesai",      label: "✅ Selesai",        symbol: "✅" },
  { value: "perpanjangan", label: "⚠️ Perpanjangan",  symbol: "⚠️" },
  { value: "cancel",       label: "⛔ Cancel",         symbol: "⛔" },
];
const BULAN = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
const HARI  = ["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"];
const DOA_PENUTUP = "Semoga pekerjaan diberikan keselamatan dan kelancaran,\nSelamat personil dan peralatannya, semakin aman andal sistemnya,\nAamiin \uD83E\uDD32\uD83C\uDFFB";
const KETERANGAN = "Keterangan :\n\u23F0 : tanggal dan waktu pelaksanaan\n\uD83C\uDF19 : padam menginap\n\uD83C\uDF1E : padam tidak menginap\n\uD83D\uDEAB : tidak padam\n\uD83D\uDD34 : belum dimulai\n\u23F3 : on progress\n\u2705 : selesai\n\u26A0\uFE0F : perpanjangan waktu\n\u26D4 : cancel\n\uD83D\uDCDD : catatan mitigasi";


const LOKASI_OPTIONS = [
  "GI 150 kV Grogot",
  "GI 150 kV Kuaro",
  "GI 150 kV Longikis",
  "GI 150 kV Petung",
  "GI 150 kV Mobile Gersik",
  "GIS 150 kV 4 IKN",
  "ULTG Paser",
  "GI 150 kV Muara Komam",
];
const formatTanggal = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return `${dt.getDate()} ${BULAN[dt.getMonth()]} ${dt.getFullYear()}`;
};
const formatHariTanggal = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return `${HARI[dt.getDay()]}, ${dt.getDate()} ${BULAN[dt.getMonth()]} ${dt.getFullYear()}`;
};
const todayISO = () => new Date().toISOString().split("T")[0];
const emptyItem = () => ({
  id: Date.now() + Math.random(),
  lokasi: "", pekerjaan: "",
  tanggalMulai: todayISO(), tanggalSelesai: todayISO(),
  jamMulai: "08.00", jamSelesai: "17.00",
  status: "tidak_padam",
  progress: "progress", progressPersen: "", isKumulatif: false,
  mitigasi: "", loadingAI: false, loadingSave: false, savedToDB: false,
  tampilJadwal: true, wpJsaFiles: [],
});

async function searchJSA(q) {
  if (!q || q.length < 3) return [];
  try {
    const res = await apiFetch(`${API_URL}/mitigasi?q=${encodeURIComponent(q)}`);
    const data = await res.json();
    return data.results || [];
  } catch { return []; }
}

async function generateAI(lokasi, pekerjaan, status) {
  try {
    const res = await apiFetch(`${API_URL}/ai-mitigasi`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ lokasi, pekerjaan, status }),
    });
    const data = await res.json();
    return data.mitigasi || "";
  } catch { return ""; }
}

async function simpanKeDB(nama_pekerjaan, mitigasi, kataKunciManual) {
  const kata_kunci = (kataKunciManual && kataKunciManual.trim())
    ? kataKunciManual.trim()
    : nama_pekerjaan.toLowerCase().split(" ").join(",");
  const res = await apiFetch(`${API_URL}/mitigasi/tambah`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ nama_pekerjaan, kata_kunci, mitigasi }),
  });
  return await res.json();
}

function catatStat(aksi, detail = "") {
  apiFetch(`${API_URL}/web-stat/catat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ aksi, detail }),
  }).catch(() => {});
}

async function simpanHistory(tanggal, internal, eksternal, mode = "pagi") {
  const items = [
    ...internal.filter(i => i.pekerjaan).map(i => ({
      tanggal, lokasi: i.lokasi, nama_pekerjaan: i.pekerjaan,
      status: STATUS_OPTIONS.find(s => s.value === i.status)?.label || "",
      progress: PROGRESS_OPTIONS.find(p => p.value === i.progress)?.label || "",
      progress_persen: i.progressPersen, section: "internal", mode,
      wp_jsa_ids: (i.wpJsaFiles || []).map(f => f.id).join(",")
    })),
    ...eksternal.filter(i => i.pekerjaan).map(i => ({
      tanggal, lokasi: i.lokasi, nama_pekerjaan: i.pekerjaan,
      status: STATUS_OPTIONS.find(s => s.value === i.status)?.label || "",
      progress: PROGRESS_OPTIONS.find(p => p.value === i.progress)?.label || "",
      progress_persen: i.progressPersen, section: "eksternal", mode,
      wp_jsa_ids: (i.wpJsaFiles || []).map(f => f.id).join(",")
    })),
  ];
  if (items.length === 0) return;
  try {
    await apiFetch(`${API_URL}/history/simpan`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });
  } catch {}
}

async function simpanDraft(tanggal, internal, eksternal) {
  try {
    const data_json = JSON.stringify({ internal, eksternal });
    await apiFetch(`${API_URL}/draft/simpan`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tanggal, data_json }),
    });
  } catch {}
}

async function ambilDraft(tanggal) {
  try {
    const res = await apiFetch(`${API_URL}/draft/${tanggal}`);
    const data = await res.json();
    if (data.status === "ok") return JSON.parse(data.data_json);
    return null;
  } catch { return null; }
}

async function listDraft() {
  try {
    const res = await apiFetch(`${API_URL}/draft/list/semua`);
    const data = await res.json();
    return data.results || [];
  } catch { return []; }
}

const C = {
  bg: "#080f1a", panel: "#0e1c2f", border: "#1e3048",
  amber: "#f59e0b", amberDim: "#92610a",
  blue: "#38bdf8", violet: "#a78bfa",
  green: "#34d399", red: "#f87171", teal: "#2dd4bf",
  text: "#e2e8f0", muted: "#64748b", subtle: "#334155",
};

const inp = {
  width: "100%", background: C.bg, border: `1px solid ${C.border}`,
  borderRadius: 8, color: C.text, padding: "10px 12px",
  fontSize: 14, outline: "none", boxSizing: "border-box", fontFamily: "inherit",
  WebkitAppearance: "none",
};
const lbl = {
  display: "block", color: C.muted, fontSize: 13, fontWeight: 700,
  marginBottom: 5, letterSpacing: 0.8, textTransform: "uppercase",
};
const btnStyle = (bg, color, border) => ({
  background: bg, border: `1px solid ${border || bg}`, color,
  borderRadius: 8, padding: "10px 16px", cursor: "pointer",
  fontSize: 13, fontWeight: 700, WebkitTapHighlightColor: "transparent",
});

function copyToClipboard(text, onSuccess) {
  // Selalu pakai fallbackCopy - terbukti lebih diandalkan di beberapa HP
  // dibanding navigator.clipboard.writeText yang kadang "berhasil" tapi clipboard kosong
  fallbackCopy(text, onSuccess);
}

function fallbackCopy(text, onSuccess) {
  try {
    const el = document.createElement("textarea");
    el.value = text; el.style.position = "fixed"; el.style.opacity = "0";
    el.style.fontSize = "16px"; document.body.appendChild(el);
    el.focus(); el.select(); el.setSelectionRange(0, 99999);
    document.execCommand("copy"); document.body.removeChild(el);
    onSuccess();
  } catch { alert("Gagal copy. Tekan lama untuk copy manual."); }
}

function ItemForm({ item, onChange, onRemove, index, accent, isInternal }) {
  const set = (f, v) => onChange({ ...item, [f]: v });
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggest, setShowSuggest] = useState(false);
  const debounceRef = useRef(null);
  const [wpJsaQuery, setWpJsaQuery] = useState("");
  const [wpJsaResults, setWpJsaResults] = useState([]);
  const [wpJsaSuggest, setWpJsaSuggest] = useState(null);
  const [showWpJsaPicker, setShowWpJsaPicker] = useState(false);
  const [cuaca, setCuaca] = useState(null);
  const [loadingCuaca, setLoadingCuaca] = useState(false);

  useEffect(() => {
    if (!item.lokasi || !item.tanggalMulai) { setCuaca(null); return; }
    setLoadingCuaca(true);
    apiFetch(`${API_URL}/cuaca?lokasi=${encodeURIComponent(item.lokasi)}&tanggal=${item.tanggalMulai}`)
      .then(res => res.json())
      .then(data => setCuaca(data))
      .catch(() => setCuaca(null))
      .finally(() => setLoadingCuaca(false));
  }, [item.lokasi, item.tanggalMulai]);

  useEffect(() => {
    if (!item.pekerjaan || item.pekerjaan.length < 4) { setWpJsaSuggest(null); return; }
    const kataKunci = item.pekerjaan.split(" ")[0];
    const t = setTimeout(async () => {
      try {
        const res = await apiFetch(`${API_URL}/wp-jsa/list?q=${encodeURIComponent(kataKunci)}&aktif_saja=true`);
        const data = await res.json();
        const sudahDipilih = (item.wpJsaFiles || []).map(f => f.id);
        const hasil = (data.results || []).filter(f => !sudahDipilih.includes(f.id));
        setWpJsaSuggest(hasil[0] || null);
      } catch { setWpJsaSuggest(null); }
    }, 600);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.pekerjaan]);

  const searchWpJsa = async (q) => {
    setWpJsaQuery(q);
    try {
      const res = await apiFetch(`${API_URL}/wp-jsa/list?q=${encodeURIComponent(q)}&aktif_saja=true`);
      const data = await res.json();
      setWpJsaResults(data.results || []);
    } catch { setWpJsaResults([]); }
  };

  const handlePekerjaanChange = (val) => {
    onChange({ ...item, pekerjaan: val, savedToDB: false });
    clearTimeout(debounceRef.current);
    if (val.length >= 3) {
      debounceRef.current = setTimeout(async () => {
        const results = await searchJSA(val);
        setSuggestions(results);
        setShowSuggest(results.length > 0);
      }, 400);
    } else { setSuggestions([]); setShowSuggest(false); }
  };

  const handlePickSuggest = (s) => {
    const mitigasiFormatted = s.mitigasi.split(/[;\n]/).map(p => p.trim().replace(/^[-\u2022]\s*/, "")).filter(p => p.length > 2).map(p => `- ${p}`).join("\n");
    onChange({ ...item, pekerjaan: s.nama_pekerjaan, mitigasi: mitigasiFormatted, savedToDB: true });
    setSuggestions([]); setShowSuggest(false);
  };

  const handleAI = async () => {
    if (!item.pekerjaan) return alert("Isi nama pekerjaan dulu.");
    onChange({ ...item, loadingAI: true });

    if (item.wpJsaFiles && item.wpJsaFiles.length > 0) {
      try {
        const res = await apiFetch(`${API_URL}/wp-jsa/ringkas-mitigasi`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ wp_jsa_ids: item.wpJsaFiles.map(f => f.id) }),
        });
        const data = await res.json();
        if (data.status === "ok") {
          catatStat("generate_ai", "dari_wp_jsa");
          onChange({ ...item, mitigasi: data.mitigasi, loadingAI: false });
          return;
        }
      } catch { /* lanjut ke fallback di bawah */ }
    }
    catatStat("generate_ai", "generic");

    const statusLabel = STATUS_OPTIONS.find(s => s.value === item.status)?.label || "";
    const result = await generateAI(item.lokasi, item.pekerjaan, statusLabel);
    if (result) onChange({ ...item, mitigasi: result, loadingAI: false });
    else { alert("Gagal generate. Coba lagi."); onChange({ ...item, loadingAI: false }); }
  };

  const handleSimpanDB = async () => {
    if (!item.pekerjaan) return alert("Isi nama pekerjaan dulu.");
    if (!item.mitigasi) return alert("Isi catatan mitigasi dulu.");
    onChange({ ...item, loadingSave: true });
    try {
      const result = await simpanKeDB(item.pekerjaan, item.mitigasi, item.kataKunci);
      if (result.status === "ok") { onChange({ ...item, loadingSave: false, savedToDB: true }); alert("Tersimpan ke database!"); }
      else { alert(`Gagal: ${result.pesan}`); onChange({ ...item, loadingSave: false }); }
    } catch { alert("Gagal terhubung."); onChange({ ...item, loadingSave: false }); }
  };

  return (
    <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderLeft: `4px solid ${accent}`, borderRadius: 12, padding: 16, marginBottom: 16 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom: 14 }}>
        <span style={{ color: accent, fontWeight: 800, fontSize: 13 }}>ITEM #{index + 1}</span>
        <button onClick={onRemove} style={{ ...btnStyle("#1f0a0a", C.red, "#3f1010"), padding: "6px 12px", fontSize: 12 }}>Hapus</button>
      </div>

      <div style={{ fontSize:10, color:C.teal, fontWeight:800, textTransform:"uppercase", letterSpacing:1, marginBottom:10 }}>📋 Info Dasar</div>
      <div style={{ marginBottom: 12 }}>
        <label style={lbl}>Lokasi</label>
        <input value={item.lokasi} onChange={e => set("lokasi", e.target.value)} list="lokasi-list" placeholder="Pilih atau ketik lokasi..." style={inp} />
        <datalist id="lokasi-list">
          {LOKASI_OPTIONS.map(l => <option key={l} value={l} />)}
        </datalist>
      </div>

      <div style={{ marginBottom: 12, position: "relative" }}>
        <label style={lbl}>Nama Pekerjaan</label>
        <input value={item.pekerjaan} onChange={e => handlePekerjaanChange(e.target.value)}
          onBlur={() => setTimeout(() => setShowSuggest(false), 200)}
          onFocus={() => suggestions.length > 0 && setShowSuggest(true)}
          placeholder="Ketik nama pekerjaan..." style={inp} />
        {showSuggest && (
          <div style={{ position:"absolute", left:0, right:0, zIndex:100, background:"#0d1f35", border:`1px solid ${C.amber}`, borderRadius:8, marginTop:2, maxHeight:180, overflowY:"auto", boxShadow:"0 8px 24px rgba(0,0,0,0.6)" }}>
            <div style={{ padding:"6px 10px", fontSize:10, color:C.amber, borderBottom:`1px solid ${C.border}`, fontWeight:700 }}>Database JSA — tap untuk pilih</div>
            {suggestions.map(s => (
              <div key={s.id} onClick={() => handlePickSuggest(s)} style={{ padding:"10px 12px", cursor:"pointer", borderBottom:`1px solid ${C.border}` }}>
                <div style={{ fontSize:13, color:C.text, fontWeight:600 }}>{s.nama_pekerjaan}</div>
                <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>{s.kata_kunci}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {isInternal && (
        <label style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 12px", background: item.tampilJadwal!==false ? "rgba(74,158,255,0.08)" : C.bg, border:`1px solid ${item.tampilJadwal!==false ? accent : C.border}`, borderRadius:8, cursor:"pointer", marginBottom:12 }}>
          <input type="checkbox" checked={item.tampilJadwal !== false} onChange={e => set("tampilJadwal", e.target.checked)} />
          <span style={{ fontSize:13, fontWeight:600, color:C.text }}>Tampilkan Jadwal & Progress</span>
        </label>
      )}

      {(!isInternal || item.tampilJadwal !== false) && (
        <>
      <div style={{ fontSize:10, color:C.teal, fontWeight:800, textTransform:"uppercase", letterSpacing:1, marginBottom:10 }}>📅 Jadwal</div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
        <div><label style={lbl}>Tgl Mulai</label><input type="date" value={item.tanggalMulai} onChange={e => set("tanggalMulai", e.target.value)} style={inp} /></div>
        <div><label style={lbl}>Tgl Selesai</label><input type="date" value={item.tanggalSelesai} onChange={e => set("tanggalSelesai", e.target.value)} style={inp} /></div>
        <div><label style={lbl}>Jam Mulai</label><input value={item.jamMulai} onChange={e => set("jamMulai", e.target.value)} placeholder="08.00" style={inp} /></div>
        <div><label style={lbl}>Jam Selesai</label><input value={item.jamSelesai} onChange={e => set("jamSelesai", e.target.value)} placeholder="17.00" style={inp} /></div>
      </div>
      {loadingCuaca && (
        <div style={{ fontSize:11, color:C.subtle, marginBottom:12 }}>⏳ Memuat prakiraan cuaca...</div>
      )}
      {isInternal && loadingCuaca && (
        <div style={{ fontSize:11, color:C.subtle, marginBottom:12 }}>⏳ Memuat prakiraan cuaca...</div>
      )}
      {isInternal && !loadingCuaca && cuaca && cuaca.status === "ok" && cuaca.prakiraan && cuaca.prakiraan.length > 0 && (() => {
        const jamMulaiNum = parseInt((item.jamMulai || "").split(/[.:]/)[0], 10);
        const jamSelesaiNum = parseInt((item.jamSelesai || "").split(/[.:]/)[0], 10);
        let slotRentang = cuaca.prakiraan;
        if (!isNaN(jamMulaiNum) && !isNaN(jamSelesaiNum)) {
          const filtered = cuaca.prakiraan.filter(p => {
            const jamSlot = parseInt(p.jam.split(":")[0], 10);
            return jamSlot >= jamMulaiNum - 2 && jamSlot <= jamSelesaiNum + 2;
          });
          if (filtered.length > 0) slotRentang = filtered;
        }
        return (
          <div style={{ background:"#0d1f2e", border:`1px solid #1a3a4a`, borderRadius:8, padding:"10px 12px", marginBottom:12, fontSize:12 }}>
            <div style={{ color:C.teal, fontWeight:700, marginBottom:6 }}>
              🌤️ Prakiraan {cuaca.nama_lokasi_bmkg}{item.jamMulai && item.jamSelesai ? ` (${item.jamMulai} - ${item.jamSelesai})` : ""}
            </div>
            {slotRentang.map((s, i) => (
              <div key={i} style={{ color:C.text, marginBottom:3, display:"flex", justifyContent:"space-between" }}>
                <span>{s.jam} — {s.cuaca}</span>
                <span style={{ color: s.curah_hujan_mm > 0 ? C.amber : C.subtle }}>
                  {s.suhu}°C{s.curah_hujan_mm > 0 ? ` · 🌧️ ${s.curah_hujan_mm}mm` : ""}
                </span>
              </div>
            ))}
            <div style={{ color:C.subtle, fontSize:10, marginTop:4 }}>Sumber: {cuaca.sumber} — referensi, bukan pengganti pantauan langsung di lapangan</div>
          </div>
        );
      })()}
      {isInternal && !loadingCuaca && cuaca && cuaca.status === "ok_multi_titik" && (
        <div style={{ background:"#0d1f2e", border:`1px solid #1a3a4a`, borderRadius:8, padding:"10px 12px", marginBottom:12, fontSize:12 }}>
          <div style={{ color:C.teal, fontWeight:700, marginBottom:4 }}>🌤️ Prakiraan (jalur SUTT, 2 titik)</div>
          {Object.entries(cuaca.titik).map(([nama, d]) => (
            <div key={nama} style={{ color:C.text, marginBottom:2 }}>
              📍 {nama}: {d.status === "ok" && d.prakiraan?.length > 0
                ? `${d.prakiraan[0].cuaca}, ${d.prakiraan[0].suhu}°C${d.prakiraan[0].curah_hujan_mm > 0 ? `, 🌧️ ${d.prakiraan[0].curah_hujan_mm}mm` : ""}`
                : (d.pesan || "data tidak tersedia")}
            </div>
          ))}
          <div style={{ color:C.subtle, fontSize:10, marginTop:2 }}>Sumber: BMKG — referensi, bukan pengganti pantauan langsung di lapangan</div>
        </div>
      )}
      {isInternal && !loadingCuaca && cuaca && cuaca.status === "di_luar_jangkauan" && (
        <div style={{ fontSize:11, color:C.subtle, marginBottom:12 }}>ℹ️ BMKG cuma sediakan prakiraan 3 hari ke depan untuk tanggal ini.</div>
      )}
      <div style={{ fontSize:10, color:C.teal, fontWeight:800, textTransform:"uppercase", letterSpacing:1, marginBottom:10 }}>📊 Status & Progress</div>
      <div style={{ marginBottom:12 }}>
        <label style={lbl}>Status Padam</label>
        <select value={item.status} onChange={e => set("status", e.target.value)} style={inp}>
          {STATUS_OPTIONS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
        <div>
          <label style={lbl}>Progress</label>
          <select value={item.progress} onChange={e => set("progress", e.target.value)} style={inp}>
            {PROGRESS_OPTIONS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
          </select>
        </div>
        <div>
          <label style={lbl}>Persentase %</label>
          <div style={{ display:"flex", gap:6, alignItems:"center" }}>
            <input type="number" min="0" max="100" inputMode="numeric" value={item.progressPersen}
              onChange={e => set("progressPersen", e.target.value)} placeholder="0" style={{ ...inp, flex:1 }} />
            <label style={{ color:C.muted, fontSize:12, display:"flex", alignItems:"center", gap:4, whiteSpace:"nowrap" }}>
              <input type="checkbox" checked={item.isKumulatif} onChange={e => set("isKumulatif", e.target.checked)} /> Kumulatif
            </label>
          </div>
        </div>
      </div>
        </>
      )}

      {wpJsaSuggest && (
        <div style={{ background:"#1a1508", border:"1px solid #854f0b", borderRadius:8, padding:10, marginBottom:10 }}>
          <div style={{ fontSize:11, color:"#ef9f27", fontWeight:700, marginBottom:6 }}>✨ Kelihatan cocok</div>
          <div style={{ display:"flex", alignItems:"center", gap:8, background:C.bg, borderRadius:6, padding:8, marginBottom:8 }}>
            <span style={{ fontSize:16 }}>📄</span>
            <span style={{ fontSize:11, color:C.text, flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{wpJsaSuggest.nama_file}</span>
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={() => { set("wpJsaFiles", [...(item.wpJsaFiles||[]), wpJsaSuggest]); setWpJsaSuggest(null); }}
              style={{ flex:1, background:"#052e16", border:"1px solid #1a4a2a", borderRadius:6, padding:7, color:"#8fd4a8", fontSize:11, fontWeight:600 }}>
              Ya, pakai ini
            </button>
            <button onClick={() => setWpJsaSuggest(null)}
              style={{ flex:1, background:"transparent", border:`1px solid ${C.subtle}`, borderRadius:6, padding:7, color:C.muted, fontSize:11 }}>
              Bukan, cari lain
            </button>
          </div>
        </div>
      )}

      <div style={{ marginBottom:12 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
          <label style={{ ...lbl, marginBottom:0 }}>WP JSA</label>
          <button onClick={() => setShowWpJsaPicker(!showWpJsaPicker)} style={{ fontSize:11, color:C.teal, background:"none", border:"none", cursor:"pointer" }}>
            {showWpJsaPicker ? "Tutup" : "+ Cari dokumen"}
          </button>
        </div>

        {(item.wpJsaFiles||[]).map(f => (
          <div key={f.id} style={{ display:"flex", alignItems:"center", gap:8, background:C.panel, border:`1px solid ${C.border}`, borderRadius:8, padding:8, marginBottom:6 }}>
            <span style={{ fontSize:14 }}>📄</span>
            <span style={{ fontSize:11, color:C.text, flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{f.nama_file}</span>
            <button onClick={() => set("wpJsaFiles", (item.wpJsaFiles||[]).filter(x => x.id !== f.id))}
              style={{ background:"none", border:"none", color:"#f87171", fontSize:14, cursor:"pointer" }}>✕</button>
          </div>
        ))}

        {showWpJsaPicker && (
          <div style={{ background:"#0a1520", border:`1px solid ${C.teal}`, borderRadius:8, padding:10 }}>
            <input value={wpJsaQuery} onChange={e => searchWpJsa(e.target.value)}
              placeholder="Cari nama file..." style={{ ...inp, fontSize:12, marginBottom:8 }} />
            {wpJsaResults.map(f => {
              const dipilih = (item.wpJsaFiles||[]).some(x => x.id === f.id);
              return (
                <label key={f.id} style={{ display:"flex", alignItems:"center", gap:8, padding:6, cursor:"pointer" }}>
                  <input type="checkbox" checked={dipilih} onChange={() => {
                    if (dipilih) set("wpJsaFiles", (item.wpJsaFiles||[]).filter(x => x.id !== f.id));
                    else set("wpJsaFiles", [...(item.wpJsaFiles||[]), f]);
                  }} />
                  <span style={{ fontSize:11, color:C.text }}>{f.nama_file}</span>
                </label>
              );
            })}
            {wpJsaResults.length === 0 && wpJsaQuery && <div style={{ fontSize:11, color:C.subtle }}>Tidak ada hasil.</div>}
          </div>
        )}
      </div>

      <div>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
          <label style={{ ...lbl, marginBottom:0 }}>Catatan Mitigasi</label>
          {item.savedToDB && <span style={{ fontSize:10, color:C.green, fontWeight:700 }}>✅ Ada di DB</span>}
        </div>
        <button onClick={handleAI} disabled={item.loadingAI} style={{
          ...btnStyle(C.bg, item.loadingAI?C.muted:C.amber, item.loadingAI?C.border:C.amberDim),
          width:"100%", fontSize:13, padding:"10px 0", marginBottom:8,
        }}>
          {item.loadingAI ? "⏳ Generating..." : "✨ Generate AI"}
        </button>
        <textarea value={item.mitigasi} onChange={e => set("mitigasi", e.target.value)}
          placeholder={"Ketik pekerjaan -> dropdown JSA muncul\natau tap ✨ Generate AI\natau isi manual"}
          rows={6} style={{ ...inp, resize:"none", lineHeight:1.7, marginBottom:8 }} />
        {!item.savedToDB && item.pekerjaan && item.mitigasi && (
          <>
            <label style={{ ...lbl, marginTop:4 }}>Kata Kunci (buat pencarian, edit kalau perlu)</label>
            <input
              value={item.kataKunci !== undefined && item.kataKunci !== "" ? item.kataKunci : item.pekerjaan.toLowerCase().split(" ").join(",")}
              onChange={e => set("kataKunci", e.target.value)}
              placeholder="misal: point to point, trafo"
              style={{ ...inp, marginBottom:10, fontSize:12 }} />
          </>
        )}
        {!item.savedToDB && item.pekerjaan && item.mitigasi && (
          <button onClick={handleSimpanDB} disabled={item.loadingSave} style={{
            ...btnStyle(item.loadingSave?C.subtle:"#0a1f10", item.loadingSave?C.muted:C.green, item.loadingSave?C.border:"#1a4a2a"),
            width:"100%", fontSize:13, padding:"10px 0",
          }}>
            {item.loadingSave ? "Menyimpan..." : "💾 Simpan ke Database JSA"}
          </button>
        )}
      </div>
    </div>
  );
}

function buildOutput(tanggalLaporan, internal, eksternal, mode) {
  const hariTgl = formatHariTanggal(tanggalLaporan);
  const header = mode === "pagi"
    ? `\uD83D\uDCDC Bismillah, Insya Allah untuk rencana pekerjaan ULTG Paser\n${hariTgl}`
    : `\uD83D\uDCDCBismillah, Progres Realisasi Pekerjaan ULTG Paser\n${hariTgl} sebagai berikut :`;
  const fmtItem = (item, num) => {
    const statusLabel = STATUS_OPTIONS.find(s => s.value === item.status)?.label || "";
    const progressSym = PROGRESS_OPTIONS.find(p => p.value === item.progress)?.symbol || "\u23F3";
    const isSameDate  = !item.tanggalSelesai || item.tanggalMulai === item.tanggalSelesai;
    const tglStr = isSameDate ? formatTanggal(item.tanggalMulai) : `${formatTanggal(item.tanggalMulai)} s.d. ${formatTanggal(item.tanggalSelesai)}`;
    let progStr = progressSym;
    if (item.progressPersen) progStr += ` (${item.progressPersen}%)${item.isKumulatif ? " Komulatif" : ""}`;
    const mitigasiLines = item.mitigasi
      ? item.mitigasi.split("\n").filter(l => l.trim()).map(l => `- ${l.replace(/^[-\u2022]\s*/, "")}`).join("\n")
      : "";
    const tampilJadwal = item.tampilJadwal !== false;
    return [
      `${num}.\u2060 \u2060${item.lokasi}`,
      `\u2022\u2060 \u2060${item.pekerjaan}`,
      tampilJadwal ? `\u23F0 ${tglStr}, ${item.jamMulai} s.d ${item.jamSelesai} WITA` : "",
      tampilJadwal ? statusLabel : "", tampilJadwal ? progStr : "",
      mitigasiLines ? `\uD83D\uDCDD ${mitigasiLines}` : "",
    ].filter(Boolean).join("\n");
  };
  const intBlock = internal.filter(i => i.lokasi || i.pekerjaan).map((i, idx) => fmtItem(i, idx+1)).join("\n\n");
  const extBlock = eksternal.filter(i => i.lokasi || i.pekerjaan).map((i, idx) => fmtItem(i, idx+1)).join("\n\n");
  const parts = ["Assalamualaikum Warohmatullahi Wabarokatu", header];
  if (intBlock) parts.push(`*Internal ULTG Paser*\n\n${intBlock}`);
  if (extBlock) parts.push(`*Eksternal ULTG Paser*\n\n${extBlock}`);
  parts.push(DOA_PENUTUP);
  parts.push(KETERANGAN);
  return parts.join("\n\n");
}

function TabRencanaMingguan() {
  const [uploading, setUploading] = useState(false);
  const [hasil, setHasil] = useState(null);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".pptx")) {
      alert("Hanya file PPTX yang didukung.");
      e.target.value = "";
      return;
    }
    setUploading(true);
    setHasil(null);
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = reader.result.split(",")[1];
      try {
        const res = await apiFetch(`${API_URL}/rencana-mingguan/upload`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ file_base64: base64 }),
        });
        const data = await res.json();
        if (data.status === "ok") {
          setHasil(data);
        } else {
          alert(`Gagal: ${data.pesan}`);
        }
      } catch { alert("Gagal upload ke server."); }
      setUploading(false);
      e.target.value = "";
    };
    reader.readAsDataURL(file);
  };

  return (
    <div>
      <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:12, padding:16, marginBottom:16 }}>
        <h2 style={{ margin:"0 0 6px 0", color:C.teal, fontSize:14, fontWeight:800 }}>📅 Rencana Mingguan</h2>
        <div style={{ fontSize:11, color:C.subtle, marginBottom:14 }}>
          Upload PPTX "Resume Rencana Kerja" tiap Jumat — sistem otomatis baca tabel Internal & Eksternal.
        </div>
        <label style={{ display:"block", border:`1px dashed ${C.teal}`, borderRadius:8, padding:20, textAlign:"center", color:C.teal, fontSize:13, cursor:"pointer" }}>
          {uploading ? "⏳ Membaca & menyimpan..." : "Tap untuk pilih file PPTX"}
          <input type="file" accept=".pptx" onChange={handleUpload} disabled={uploading} style={{ display:"none" }} />
        </label>
      </div>

      {hasil && (
        <div style={{ background:"#052e16", border:"1px solid #1a4a2a", borderRadius:10, padding:14 }}>
          <div style={{ color:"#8fd4a8", fontSize:13, fontWeight:700, marginBottom:4 }}>✅ Berhasil diimpor</div>
          <div style={{ color:"#8fd4a8", fontSize:12 }}>{hasil.jumlah_internal} pekerjaan Internal, {hasil.jumlah_eksternal} pekerjaan Eksternal</div>
          <div style={{ color:"#6b8577", fontSize:11, marginTop:2 }}>Periode: {hasil.periode}</div>
        </div>
      )}

      <div style={{ marginTop:16, background:"#0f2744", border:`1px solid ${C.blue}`, borderRadius:10, padding:12, fontSize:12, color:"#85b7eb" }}>
        💡 Setelah upload, tiap malam tap "Muat dari Rencana Mingguan" di tab Input untuk isi otomatis.
      </div>
    </div>
  );
}
function TabStatistik() {
  const [botRekap, setBotRekap] = useState(null);
  const [webRekap, setWebRekap] = useState(null);
  const [rekapKerja, setRekapKerja] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const [resBot, resWeb, resKerja] = await Promise.all([
          apiFetch(`${API_URL}/bot-log/rekap`),
          apiFetch(`${API_URL}/web-stat/rekap`),
          apiFetch(`${API_URL}/rekap/bulanan`),
        ]);
        setBotRekap(await resBot.json());
        setWebRekap(await resWeb.json());
        setRekapKerja(await resKerja.json());
      } catch { alert("Gagal memuat statistik."); }
      setLoading(false);
    })();
  }, []);

  const BarRow = ({ label, jumlah, max, warna }) => (
    <div style={{ marginBottom:10 }}>
      <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:C.text, marginBottom:3 }}>
        <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"75%" }}>{label}</span>
        <span style={{ fontWeight:700, color:warna }}>{jumlah}</span>
      </div>
      <div style={{ background:C.bg, borderRadius:6, height:8, overflow:"hidden" }}>
        <div style={{ width:`${Math.max(4,(jumlah/max)*100)}%`, background:warna, height:"100%", borderRadius:6 }} />
      </div>
    </div>
  );

  if (loading) return <div style={{ textAlign:"center", color:C.subtle, padding:30 }}>Memuat statistik...</div>;

  return (
    <div>
      <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:12, padding:16, marginBottom:16 }}>
        <h2 style={{ margin:"0 0 14px 0", color:C.teal, fontSize:14, fontWeight:800 }}>🤖 Cek Kerjo (Bot Telegram)</h2>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:16 }}>
          <div style={{ background:C.bg, borderRadius:8, padding:12, textAlign:"center" }}>
            <div style={{ fontSize:24, fontWeight:800, color:C.blue }}>{botRekap?.total_user || 0}</div>
            <div style={{ fontSize:11, color:C.muted }}>Pengguna unik</div>
          </div>
          <div style={{ background:C.bg, borderRadius:8, padding:12, textAlign:"center" }}>
            <div style={{ fontSize:24, fontWeight:800, color:C.amber }}>{botRekap?.total_pesan || 0}</div>
            <div style={{ fontSize:11, color:C.muted }}>Total pesan</div>
          </div>
        </div>
        <div style={{ fontSize:11, color:C.subtle, fontWeight:700, marginBottom:8, textTransform:"uppercase" }}>Per Pengguna</div>
        {(botRekap?.per_user || []).length === 0 && (
          <div style={{ textAlign:"center", color:C.subtle, padding:16, fontSize:12 }}>Belum ada data.</div>
        )}
        {(botRekap?.per_user || []).map((u, i) => (
          <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:i < botRekap.per_user.length-1 ? `1px solid ${C.border}` : "none" }}>
            <div>
              <div style={{ fontSize:12, color:C.text }}>{u.nama_user || "(tanpa nama)"}</div>
              <div style={{ fontSize:10, color:C.subtle }}>{u.username ? `@${u.username}` : ""}</div>
            </div>
            <div style={{ textAlign:"right" }}>
              <div style={{ fontSize:13, color:C.blue, fontWeight:700 }}>{u.jumlah_pesan}x</div>
              <div style={{ fontSize:9, color:C.subtle }}>{formatTanggal(u.terakhir_aktif?.slice(0,10))}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:12, padding:16, marginBottom:16 }}>
        <h2 style={{ margin:"0 0 4px 0", color:C.teal, fontSize:14, fontWeight:800 }}>📊 Rekap Pekerjaan Bulan Ini</h2>
        <div style={{ fontSize:11, color:C.subtle, marginBottom:14 }}>Dihitung unik per pekerjaan (tidak dobel dari entri Malam/Sore)</div>

        <div style={{ background:C.bg, borderRadius:8, padding:14, textAlign:"center", marginBottom:16 }}>
          <div style={{ fontSize:32, fontWeight:800, color:C.amber }}>{rekapKerja?.total_bulan_ini || 0}</div>
          <div style={{ fontSize:11, color:C.muted }}>Total pekerjaan bulan ini</div>
        </div>

        <div style={{ fontSize:11, color:C.subtle, fontWeight:700, marginBottom:8, textTransform:"uppercase" }}>Internal vs Eksternal</div>
        {(() => {
          const maxSec = Math.max(1, ...(rekapKerja?.per_section || []).map(s => s.jumlah));
          return (rekapKerja?.per_section || []).map((s, i) => (
            <BarRow key={i} label={s.section === "internal" ? "Internal ULTG Paser" : "Eksternal"} jumlah={s.jumlah} max={maxSec} warna={s.section === "internal" ? C.blue : C.violet} />
          ));
        })()}

        <div style={{ fontSize:11, color:C.subtle, fontWeight:700, marginTop:14, marginBottom:8, textTransform:"uppercase" }}>Top 10 Lokasi</div>
        {(() => {
          const maxLok = Math.max(1, ...(rekapKerja?.per_lokasi || []).map(l => l.jumlah));
          return (rekapKerja?.per_lokasi || []).map((l, i) => (
            <BarRow key={i} label={l.lokasi} jumlah={l.jumlah} max={maxLok} warna={C.teal} />
          ));
        })()}

        <div style={{ fontSize:11, color:C.subtle, fontWeight:700, marginTop:14, marginBottom:8, textTransform:"uppercase" }}>Status Padam</div>
        {(() => {
          const maxSt = Math.max(1, ...(rekapKerja?.per_status || []).map(s => s.jumlah));
          return (rekapKerja?.per_status || []).map((s, i) => (
            <BarRow key={i} label={s.status} jumlah={s.jumlah} max={maxSt} warna={C.amber} />
          ));
        })()}
      </div>

      <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:12, padding:16 }}>
        <h2 style={{ margin:"0 0 14px 0", color:C.teal, fontSize:14, fontWeight:800 }}>🌐 Aplikasi Web (Anonim)</h2>
        {(webRekap?.per_aksi || []).length === 0 && (
          <div style={{ textAlign:"center", color:C.subtle, padding:16, fontSize:12 }}>Belum ada data.</div>
        )}
        {(webRekap?.per_aksi || []).filter(a => a.aksi !== "generate_laporan").map((a, i) => {
          const label = {
            generate_ai: "✨ Generate AI (Catatan Mitigasi)",
            kirim_pdf_wa: "📤 Kirim Semua PDF ke WA",
          }[a.aksi] || a.aksi;
          return (
            <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:i < webRekap.per_aksi.length-1 ? `1px solid ${C.border}` : "none" }}>
              <div style={{ fontSize:12, color:C.text }}>{label}</div>
              <div style={{ fontSize:15, color:C.amber, fontWeight:800 }}>{a.jumlah}x</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
function TabWpJsa() {
  const [files, setFiles] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const loadFiles = async (q = "") => {
    setLoading(true);
    try {
      const res = await apiFetch(`${API_URL}/wp-jsa/list?q=${encodeURIComponent(q)}`);
      const data = await res.json();
      setFiles(data.results || []);
    } catch { alert("Gagal memuat daftar dokumen."); }
    setLoading(false);
  };

  useEffect(() => { loadFiles(); }, []);

  const uploadSatuFile = (file) => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = reader.result.split(",")[1];
      try {
        const res = await apiFetch(`${API_URL}/wp-jsa/upload`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ nama_file: file.name, file_base64: base64 }),
        });
        const data = await res.json();
        resolve({ nama: file.name, ok: data.status === "ok", pesan: data.pesan, tanggal_mulai: data.tanggal_mulai });
      } catch {
        resolve({ nama: file.name, ok: false, pesan: "Gagal terhubung ke server" });
      }
    };
    reader.readAsDataURL(file);
  });

  const handleUpload = async (e) => {
    const fileList = Array.from(e.target.files || []);
    if (fileList.length === 0) return;

    const bukanPdf = fileList.filter(f => !f.name.toLowerCase().endsWith(".pdf"));
    if (bukanPdf.length > 0) {
      alert(`File ini bukan PDF, dilewati: ${bukanPdf.map(f => f.name).join(", ")}`);
    }
    const fileValid = fileList.filter(f => f.name.toLowerCase().endsWith(".pdf"));
    if (fileValid.length === 0) { e.target.value = ""; return; }

    setUploading(true);
    const hasil = [];
    for (const file of fileValid) {
      const r = await uploadSatuFile(file);
      hasil.push(r);
    }
    setUploading(false);
    e.target.value = "";

    const berhasil = hasil.filter(h => h.ok);
    const gagal = hasil.filter(h => !h.ok);
    let ringkasan = `✅ ${berhasil.length} dari ${hasil.length} file berhasil diupload.`;
    if (gagal.length > 0) {
      ringkasan += `\n\n❌ Gagal:\n` + gagal.map(g => `- ${g.nama}: ${g.pesan}`).join("\n");
    }
    alert(ringkasan);
    loadFiles(search);
  };

  return (
    <div>
      <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:12, padding:16, marginBottom:16 }}>
        <h2 style={{ margin:"0 0 10px 0", color:C.teal, fontSize:14, fontWeight:800 }}>📄 Upload Dokumen WP JSA</h2>
        <label style={{ display:"block", border:`1px dashed ${C.teal}`, borderRadius:8, padding:20, textAlign:"center", color:C.teal, fontSize:13, cursor:"pointer" }}>
          {uploading ? "⏳ Mengupload..." : "Tap untuk pilih file PDF (bisa lebih dari 1)"}
          <input type="file" accept="application/pdf" multiple onChange={handleUpload} disabled={uploading} style={{ display:"none" }} />
        </label>
        <div style={{ fontSize:11, color:C.subtle, marginTop:8 }}>
          Tanggal mulai/selesai akan terdeteksi otomatis dari dokumen.
        </div>
      </div>

      <div style={{ marginBottom:12 }}>
        <input value={search} onChange={e => { setSearch(e.target.value); loadFiles(e.target.value); }}
          placeholder="Cari nama file..." style={inp} />
      </div>

      {loading && <div style={{ textAlign:"center", color:C.subtle, padding:20 }}>Memuat...</div>}
      {!loading && files.length === 0 && (
        <div style={{ textAlign:"center", color:C.subtle, padding:20, border:`1px dashed ${C.border}`, borderRadius:10 }}>
          Belum ada dokumen. Upload dulu di atas.
        </div>
      )}
      {files.map(f => (
        <div key={f.id} style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:10, padding:12, marginBottom:8, display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:20 }}>📄</span>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:12, color:C.text, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{f.nama_file}</div>
            <div style={{ fontSize:10, color:C.subtle }}>
              {f.tanggal_mulai ? `📅 ${formatTanggal(f.tanggal_mulai)}` : "Tanggal tidak terdeteksi"}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
function TabKelolaDB() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [hapusDuplikatLoading, setHapusDuplikatLoading] = useState(false);

  const loadEntries = async () => {
    setLoading(true);
    try {
      const res = await apiFetch(`${API_URL}/mitigasi/semua`);
      const data = await res.json();
      setEntries(data.results || []);
    } catch { alert("Gagal memuat database."); }
    setLoading(false);
  };

  useEffect(() => { loadEntries(); }, []);

  const handleHapus = async (id, nama) => {
    if (!window.confirm(`Hapus "${nama}"?`)) return;
    try {
      const res = await apiFetch(`${API_URL}/mitigasi/${id}`, { method: "DELETE" });
      const data = await res.json();
      if (data.status === "ok") {
        setEntries(prev => prev.filter(e => e.id !== id));
      } else {
        alert(`Gagal: ${data.pesan}`);
      }
    } catch { alert("Gagal terhubung."); }
  };

  const handleHapusDuplikat = async () => {
    if (!window.confirm("Hapus semua duplikat otomatis? Data yang tersisa adalah entri pertama dari setiap nama pekerjaan.")) return;
    setHapusDuplikatLoading(true);
    try {
      const res = await apiFetch(`${API_URL}/mitigasi/duplikat/bersihkan`, { method: "DELETE" });
      const data = await res.json();
      if (data.status === "ok") {
        alert(`${data.terhapus} duplikat berhasil dihapus!`);
        loadEntries();
      } else {
        alert(`Gagal: ${data.pesan}`);
      }
    } catch { alert("Gagal terhubung."); }
    setHapusDuplikatLoading(false);
  };

  const filtered = entries.filter(e =>
    e.nama_pekerjaan.toLowerCase().includes(search.toLowerCase()) ||
    (e.kata_kunci || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:10, padding:14, marginBottom:14 }}>
        <div style={{ color:C.amber, fontWeight:700, fontSize:13, marginBottom:10 }}>🗄️ Kelola Database JSA</div>
        <input value={search} onChange={e => setSearch(e.target.value)}
          placeholder="Cari nama pekerjaan..." style={{ ...inp, marginBottom:10 }} />
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={loadEntries} style={{ ...btnStyle(C.bg, C.teal, "#1a4a2a"), flex:1, padding:"9px 0", fontSize:12 }}>
            🔄 Refresh
          </button>
          <button onClick={handleHapusDuplikat} disabled={hapusDuplikatLoading} style={{
            ...btnStyle(C.bg, hapusDuplikatLoading?C.muted:C.red, hapusDuplikatLoading?C.border:"#4a1010"),
            flex:1, padding:"9px 0", fontSize:12
          }}>
            {hapusDuplikatLoading ? "Membersihkan..." : "🧹 Hapus Duplikat"}
          </button>
        </div>
      </div>

      {loading && <div style={{ textAlign:"center", color:C.muted, padding:20 }}>Memuat...</div>}

      <div style={{ fontSize:11, color:C.muted, marginBottom:8 }}>
        {filtered.length} dari {entries.length} entri
      </div>

      {filtered.map(e => (
        <div key={e.id} style={{ background:C.panel, border:`1px solid ${C.border}`, borderLeft:`4px solid ${C.teal}`, borderRadius:10, padding:14, marginBottom:10 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:6 }}>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:13, color:C.text, fontWeight:700 }}>{e.nama_pekerjaan}</div>
              <div style={{ fontSize:10, color:C.muted, marginTop:3 }}>ID: {e.id} &nbsp;|&nbsp; 🔑 {e.kata_kunci}</div>
            </div>
            <button onClick={() => handleHapus(e.id, e.nama_pekerjaan)} style={{
              ...btnStyle("#1f0a0a", C.red, "#3f1010"),
              padding:"5px 10px", fontSize:11, marginLeft:8, flexShrink:0,
            }}>🗑️</button>
          </div>
          <div style={{ fontSize:11, color:C.muted, lineHeight:1.5, maxHeight:60, overflow:"hidden" }}>
            {e.mitigasi?.substring(0,120)}...
          </div>
        </div>
      ))}

      {filtered.length === 0 && !loading && (
        <div style={{ textAlign:"center", color:C.subtle, padding:"32px 0", fontSize:12 }}>
          Tidak ada entri ditemukan.
        </div>
      )}
    </div>
  );
}

function TabHistory() {
  const [mode, setMode] = useState("nama");
  const [query, setQuery] = useState("");
  const [tanggal, setTanggal] = useState(todayISO());
  const [bulan, setBulan] = useState(new Date().toISOString().slice(0,7));
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const cari = async () => {
    setLoading(true);
    try {
      let url = `${API_URL}/history?`;
      if (mode === "nama") url += `q=${encodeURIComponent(query)}`;
      if (mode === "tanggal") url += `tanggal=${tanggal}`;
      if (mode === "bulan") url += `bulan=${bulan}`;
      const res = await fetch(url);
      const data = await res.json();
      setResults(data.results || []);
    } catch { alert("Gagal mengambil data history."); }
    setLoading(false);
  };

  return (
    <div>
      <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:10, padding:14, marginBottom:14 }}>
        <div style={{ color:C.amber, fontWeight:700, fontSize:13, marginBottom:12 }}>🔍 Cari History Pekerjaan</div>
        <div style={{ display:"flex", gap:6, marginBottom:12 }}>
          {[{key:"nama",label:"By Nama"},{key:"tanggal",label:"By Tanggal"},{key:"bulan",label:"By Bulan"}].map(m => (
            <button key={m.key} onClick={() => setMode(m.key)} style={{
              flex:1, padding:"8px 0", background:"none",
              border:`1px solid ${mode===m.key?C.amber:C.border}`,
              color: mode===m.key?C.amber:C.muted,
              borderRadius:8, cursor:"pointer", fontSize:11, fontWeight:mode===m.key?700:400,
              WebkitTapHighlightColor:"transparent",
            }}>{m.label}</button>
          ))}
        </div>
        {mode === "nama" && <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Nama pekerjaan / lokasi..." style={{ ...inp, marginBottom:10 }} />}
        {mode === "tanggal" && <input type="date" value={tanggal} onChange={e => setTanggal(e.target.value)} style={{ ...inp, marginBottom:10 }} />}
        {mode === "bulan" && <input type="month" value={bulan} onChange={e => setBulan(e.target.value)} style={{ ...inp, marginBottom:10 }} />}
        <button onClick={cari} disabled={loading} style={{
          ...btnStyle(C.bg, loading?C.muted:C.teal, loading?C.border:"#1a4a2a"),
          width:"100%", padding:"10px 0",
        }}>
          {loading ? "Mencari..." : "🔍 Cari"}
        </button>
      </div>

      {results.length === 0 && !loading && (
        <div style={{ textAlign:"center", color:C.subtle, padding:"32px 0", fontSize:12 }}>
          Belum ada hasil. Coba cari pekerjaan di atas.
        </div>
      )}
      {results.map(r => (
        <div key={r.id} style={{ background:C.panel, border:`1px solid ${C.border}`, borderLeft:`4px solid ${r.section==="internal"?C.blue:C.violet}`, borderRadius:10, padding:14, marginBottom:10 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:6 }}>
            <div style={{ fontSize:13, color:C.text, fontWeight:700, flex:1 }}>{r.nama_pekerjaan}</div>
            <span style={{ fontSize:10, color:r.section==="internal"?C.blue:C.violet, fontWeight:700, marginLeft:8 }}>{r.section?.toUpperCase()}</span>
          </div>
          <div style={{ fontSize:11, color:C.muted, marginBottom:4 }}>{r.lokasi}</div>
          <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
            <span style={{ fontSize:11, color:C.amber }}>📅 {formatTanggal(r.tanggal)}</span>
            <span style={{ fontSize:11, color:C.muted }}>{r.status}</span>
            <span style={{ fontSize:11, color:C.green }}>{r.progress} {r.progress_persen ? `(${r.progress_persen}%)` : ""}</span>
          </div>
        </div>
      ))}
      {results.length > 0 && (
        <div style={{ textAlign:"center", color:C.muted, fontSize:11, marginTop:8 }}>{results.length} pekerjaan ditemukan</div>
      )}
    </div>
  );
}

function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (res.ok && data.token) {
        localStorage.setItem("ultg_auth_token", data.token);
        onLogin();
      } else {
        setError(data.detail || "Username atau password salah.");
      }
    } catch {
      setError("Gagal terhubung ke server.");
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:"100vh", background:C.bg, color:C.text, fontFamily:"'Inter','Segoe UI',sans-serif", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ maxWidth:340, width:"100%" }}>
        <div style={{ textAlign:"center", marginBottom:24 }}>
          <div style={{ background:C.amber, borderRadius:12, width:56, height:56, display:"flex", alignItems:"center", justifyContent:"center", fontSize:28, margin:"0 auto 12px" }}>⚡</div>
          <div style={{ fontWeight:800, fontSize:18, color:"#f8fafc" }}>ULTG Paser</div>
          <div style={{ fontSize:12, color:C.muted }}>Masuk untuk melanjutkan</div>
        </div>
        <form onSubmit={handleSubmit} style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:12, padding:20 }}>
          <label style={lbl}>Username</label>
          <input value={username} onChange={e => setUsername(e.target.value)} style={{ ...inp, marginBottom:14 }} autoFocus />
          <label style={lbl}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} style={{ ...inp, marginBottom:16 }} />
          {error && <div style={{ color:C.red, fontSize:12, marginBottom:12 }}>{error}</div>}
          <button type="submit" disabled={loading} style={{
            width:"100%", background: loading ? C.subtle : `linear-gradient(135deg,${C.amber},#d97706)`,
            border:"none", color:C.bg, borderRadius:10, padding:"12px 0",
            fontSize:14, fontWeight:800, cursor: loading ? "default" : "pointer",
          }}>
            {loading ? "Memproses..." : "Masuk"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default function App() {
  const [authToken, setAuthToken] = useState(() => localStorage.getItem("ultg_auth_token"));
  const [tanggal,    setTanggal]    = useState(todayISO());
  const [internal,   setInternal]   = useState([emptyItem()]);
  const [eksternal,  setEksternal]  = useState([]);
  const [tab,        setTab]        = useState("form");
  const [showLainnya, setShowLainnya] = useState(false);
  const [loadingGenerate, setLoadingGenerate] = useState(false);
  const [filePdfSiap, setFilePdfSiap] = useState([]);

  useEffect(() => {
    const semuaFile = [...internal, ...eksternal].flatMap(i => i.wpJsaFiles || []);
    const unik = Array.from(new Map(semuaFile.map(f => [f.id, f])).values());
    if (unik.length === 0) { setFilePdfSiap([]); return; }
    let batal = false;
    Promise.all(unik.map(async f => {
      const res = await fetch(`/uploads/wp-jsa/${f.path_file}`);
      const blob = await res.blob();
      return new File([blob], f.nama_file, { type: "application/pdf" });
    })).then(hasil => { if (!batal) setFilePdfSiap(hasil); }).catch(() => { if (!batal) setFilePdfSiap([]); });
    return () => { batal = true; };
  }, [internal, eksternal]);
  const [showOnboarding, setShowOnboarding] = useState(() => {
    try { return !localStorage.getItem("ultg_onboarding_seen"); } catch { return false; }
  });
  const tutupOnboarding = () => {
    try { localStorage.setItem("ultg_onboarding_seen", "1"); } catch {}
    setShowOnboarding(false);
  };
  const [outputPagi, setOutputPagi] = useState("");
  const [outputSore, setOutputSore] = useState("");
  const [copied,     setCopied]     = useState("");
  const [dbStatus,   setDbStatus]   = useState("checking");
  const [draftList,  setDraftList]  = useState([]);
  const [loadingDraft, setLoadingDraft] = useState(false);
  const [draftLoaded,  setDraftLoaded]  = useState(false);

  useEffect(() => {
    apiFetch(`${API_URL}/`).then(r => r.json()).then(() => setDbStatus("online")).catch(() => setDbStatus("offline"));
    // Auto load draft hari ini
    loadDraftHariIni();
    // Load daftar draft
    listDraft().then(setDraftList);
  }, []);

  const loadDraftHariIni = async () => {
    setLoadingDraft(true);
    const tgl = todayISO();
    const draft = await ambilDraft(tgl);
    if (draft) {
      const int = draft.internal || [emptyItem()];
      const ext = draft.eksternal || [];
      setTanggal(tgl);
      setInternal(int);
      setEksternal(ext);
      setDraftLoaded(true);
      // Auto generate output supaya laporan pagi & sore langsung tersedia
      setOutputPagi(buildOutput(tgl, int, ext, "pagi"));
      setOutputSore(buildOutput(tgl, int, ext, "sore"));
    }
    setLoadingDraft(false);
  };

  const loadDraftTanggal = async (tgl) => {
    const draft = await ambilDraft(tgl);
    if (draft) {
      const int = draft.internal || [emptyItem()];
      const ext = draft.eksternal || [];
      setTanggal(tgl);
      setInternal(int);
      setEksternal(ext);
      setDraftLoaded(true);
      setOutputPagi(buildOutput(tgl, int, ext, "pagi"));
      setOutputSore(buildOutput(tgl, int, ext, "sore"));
      setTab("pagi");
      alert(`Draft ${formatTanggal(tgl)} berhasil dimuat!`);
    } else {
      alert("Draft tidak ditemukan.");
    }
  };

  const addItem    = (set) => set(p => [...p, emptyItem()]);
  const removeItem = (set, id) => set(p => p.filter(i => i.id !== id));
  const updateItem = (set, id, v) => set(p => p.map(i => i.id === id ? v : i));

  const handleGenerate = async () => {
    setLoadingGenerate(true);
    catatStat("generate_laporan", tanggal);
    setOutputPagi(buildOutput(tanggal, internal, eksternal, "pagi"));
    setOutputSore(buildOutput(tanggal, internal, eksternal, "sore"));
    await simpanDraft(tanggal, internal, eksternal);
    await simpanHistory(tanggal, internal, eksternal, "pagi");
    listDraft().then(setDraftList);
    setLoadingGenerate(false);
    setTab("pagi");
  };

  const [loadingRencanaMingguan, setLoadingRencanaMingguan] = useState(false);
  const handleMuatRencanaMingguan = async () => {
    setLoadingRencanaMingguan(true);
    try {
      const res = await apiFetch(`${API_URL}/rencana-mingguan/aktif?tanggal=${tanggal}`);
      const data = await res.json();
      const items = data.results || [];
      if (items.length === 0) {
        alert("Tidak ada rencana kerja untuk tanggal ini.\nPastikan sudah upload PPTX Rencana Mingguan minggu ini.");
        setLoadingRencanaMingguan(false);
        return;
      }
      const petaStatus = { "Padam": "padam_tidak_menginap", "Tidak Padam": "tidak_padam" };
      let petaCocok = {};
      try {
        const resAI = await apiFetch(`${API_URL}/mitigasi/cocok-ai`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ uraian: items.map(r => r.uraian_pekerjaan || "") }),
        });
        const dataAI = await resAI.json();
        (dataAI.hasil || []).forEach(h => { petaCocok[h.uraian] = h; });
      } catch { /* mitigasi dikosongkan kalau gagal */ }
      const buatItem = async (r) => {
        const cocok = petaCocok[r.uraian_pekerjaan || ""];
        const mitigasiOtomatis = (cocok && cocok.mitigasi) ? cocok.mitigasi : "";
        return {
          ...emptyItem(),
          lokasi: r.lokasi || "",
          pekerjaan: r.uraian_pekerjaan || "",
          tanggalMulai: r.tanggal_mulai,
          tanggalSelesai: r.tanggal_selesai,
          status: petaStatus[r.keterangan] || "tidak_padam",
          mitigasi: mitigasiOtomatis,
        };
      };
      const internalBaru = await Promise.all(items.filter(r => r.section === "internal").map(buatItem));
      const eksternalBaru = await Promise.all(items.filter(r => r.section === "eksternal").map(buatItem));
      setInternal(internalBaru);
      setEksternal(eksternalBaru);
      const ringkas = Object.values(petaCocok).filter(h => h.jsa_id).map(h => `• ${h.uraian} → ${h.nama_pekerjaan} [${h.sumber}]`).join("\n");
      alert(`✅ ${items.length} pekerjaan berhasil dimuat dari Rencana Mingguan (menggantikan isian sebelumnya).` + (ringkas ? `\n\nMitigasi terisi (periksa kecocokannya):\n${ringkas}` : `\n\nTidak ada mitigasi yang cocok (dikosongkan).`));
    } catch {
      alert("Gagal memuat rencana mingguan.");
    }
    setLoadingRencanaMingguan(false);
  };
  const handleCopy = (text, key) => {
    copyToClipboard(text, () => { setCopied(key); setTimeout(() => setCopied(""), 2000); });
  };

  if (!authToken) {
    return <LoginScreen onLogin={() => setAuthToken(localStorage.getItem("ultg_auth_token"))} />;
  }

  return (
    <div style={{ minHeight:"100vh", background:C.bg, color:C.text, fontFamily:"'Inter','Segoe UI',sans-serif", maxWidth:480, margin:"0 auto" }}>
      {showOnboarding && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.75)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
          <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:16, padding:22, maxWidth:380, maxHeight:"85vh", overflowY:"auto" }}>
            <div style={{ fontSize:20, fontWeight:800, color:C.amber, marginBottom:4 }}>👋 Selamat datang!</div>
            <div style={{ fontSize:13, color:C.muted, marginBottom:18 }}>Aplikasi Rencana Kerja ULTG Paser — panduan singkat sebelum mulai:</div>
            <div style={{ display:"flex", flexDirection:"column", gap:14, marginBottom:20 }}>
              <div style={{ display:"flex", gap:12 }}>
                <span style={{ fontSize:20 }}>📝</span>
                <div>
                  <div style={{ fontSize:13, fontWeight:700, color:C.text }}>Tab Input</div>
                  <div style={{ fontSize:12, color:C.muted }}>Isi pekerjaan Internal & Eksternal. Ketik nama pekerjaan, JSA otomatis disarankan.</div>
                </div>
              </div>
              <div style={{ display:"flex", gap:12 }}>
                <span style={{ fontSize:20 }}>🌙</span>
                <div>
                  <div style={{ fontSize:13, fontWeight:700, color:C.text }}>Generate Laporan</div>
                  <div style={{ fontSize:12, color:C.muted }}>Tap "Generate Laporan Malam & Sore" — laporan siap kirim ke WA otomatis.</div>
                </div>
              </div>
              <div style={{ display:"flex", gap:12 }}>
                <span style={{ fontSize:20 }}>📄</span>
                <div>
                  <div style={{ fontSize:13, fontWeight:700, color:C.text }}>Tab WP JSA</div>
                  <div style={{ fontSize:12, color:C.muted }}>Upload dokumen Working Permit — bisa ditempel ke pekerjaan & ditanya lewat bot Cek Kerjo.</div>
                </div>
              </div>
              <div style={{ display:"flex", gap:12 }}>
                <span style={{ fontSize:20 }}>🤖</span>
                <div>
                  <div style={{ fontSize:13, fontWeight:700, color:C.text }}>Cek Kerjo (Telegram)</div>
                  <div style={{ fontSize:12, color:C.muted }}>Tanya riwayat kerja atau isi WP JSA langsung lewat chat bot Telegram.</div>
                </div>
              </div>
            </div>
            <button onClick={tutupOnboarding} style={{
              width:"100%", background:`linear-gradient(135deg,${C.amber},#d97706)`,
              border:"none", color:C.bg, borderRadius:10, padding:"12px 0",
              fontSize:14, fontWeight:800, cursor:"pointer",
            }}>Mengerti, Mulai! 🚀</button>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{ background:"linear-gradient(135deg,#0e2240,#0e1c2f)", borderBottom:`2px solid ${C.amber}`, padding:"12px 16px", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:50 }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={{ background:C.amber, borderRadius:8, width:34, height:34, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18 }}>⚡</div>
          <div>
            <div style={{ fontWeight:800, fontSize:14, color:"#f8fafc" }}>ULTG Paser</div>
            <div style={{ fontSize:10, color:C.muted }}>
              {loadingDraft ? "Memuat draft..." : draftLoaded ? "✅ Draft dimuat" : "Laporan Harian"}
            </div>
          </div>
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <button onClick={() => {
            apiFetch(`${API_URL}/auth/logout`, { method: "POST" }).finally(() => {
              localStorage.removeItem("ultg_auth_token");
              window.location.reload();
            });
          }} title="Keluar" style={{
            ...btnStyle("#1f0a0a", C.red, "#3f1010"),
            width:26, height:26, borderRadius:"50%", padding:0,
            fontSize:13, WebkitTapHighlightColor:"transparent",
          }}>⏻</button>
          <button onClick={() => setShowOnboarding(true)} title="Lihat panduan" style={{
            ...btnStyle("#1f0a0a", C.red, "#3f1010"),
            width:26, height:26, borderRadius:"50%", padding:0,
            fontSize:13, fontWeight:800, WebkitTapHighlightColor:"transparent",
          }}>?</button>
          <div style={{ display:"flex", alignItems:"center", gap:5, background:C.panel, border:`1px solid ${C.border}`, borderRadius:16, padding:"4px 10px", fontSize:10 }}>
            <div style={{ width:6, height:6, borderRadius:"50%", background:dbStatus==="online"?C.green:dbStatus==="offline"?C.red:C.amber }} />
            <span style={{ color:dbStatus==="online"?C.green:dbStatus==="offline"?C.red:C.amber }}>
              {dbStatus==="online"?"DB Online":dbStatus==="offline"?"DB Offline":"Checking..."}
            </span>
          </div>
        </div>
      </div>

      {/* Tab bar */}
      <div style={{ display:"flex", background:"#0a1628", borderBottom:`1px solid ${C.border}`, position:"sticky", top:58, zIndex:49 }}>
        {[
          {key:"form",    label:"Input"},
          {key:"pagi",    label:"Malam"},
          {key:"sore",    label:"Sore"},
          {key:"wpjsa",   label:"WP JSA"},
          {key:"statistik", label:"Statistik"},
        ].map(t => (
          <button key={t.key} onClick={() => { setTab(t.key); setShowLainnya(false); }} style={{
            flex:1, padding:"12px 0", background:"none", border:"none",
            borderBottom: tab===t.key?`2px solid ${C.amber}`:"2px solid transparent",
            color: tab===t.key?C.amber:C.muted,
            cursor:"pointer", fontSize:11, fontWeight:tab===t.key?700:400,
            WebkitTapHighlightColor:"transparent",
          }}>{t.label}</button>
        ))}
        <div style={{ position:"relative", flex:1 }}>
          <button onClick={() => setShowLainnya(v => !v)} style={{
            width:"100%", padding:"12px 0", background:"none", border:"none",
            borderBottom: (tab==="history"||tab==="kelola")?`2px solid ${C.amber}`:"2px solid transparent",
            color: (tab==="history"||tab==="kelola")?C.amber:C.muted,
            cursor:"pointer", fontSize:11, fontWeight:(tab==="history"||tab==="kelola")?700:400,
            WebkitTapHighlightColor:"transparent",
          }}>Lainnya ▾</button>
          {showLainnya && (
            <div style={{ position:"absolute", top:"100%", right:0, background:C.panel, border:`1px solid ${C.border}`, borderRadius:8, overflow:"hidden", zIndex:50, minWidth:140, boxShadow:"0 4px 12px rgba(0,0,0,0.4)" }}>
              {[{key:"history",label:"History"},{key:"kelola",label:"Kelola DB"},{key:"rencanamingguan",label:"Rencana Mingguan"}].map(t => (
                <button key={t.key} onClick={() => { setTab(t.key); setShowLainnya(false); }} style={{
                  display:"block", width:"100%", textAlign:"left", padding:"12px 14px",
                  background: tab===t.key?"#1a2942":"none", border:"none",
                  color: tab===t.key?C.amber:C.text, cursor:"pointer", fontSize:12,
                  WebkitTapHighlightColor:"transparent",
                }}>{t.label}</button>
              ))}
            </div>
          )}
        </div>
      </div>

      <div style={{ padding:"16px 14px", paddingBottom:80 }}>

        {tab === "form" && (
          <>
            <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:10, padding:14, marginBottom:16 }}>
              <label style={lbl}>Tanggal Laporan</label>
              <input type="date" value={tanggal} onChange={e => setTanggal(e.target.value)} style={inp} />
            </div>
            <button onClick={handleMuatRencanaMingguan} disabled={loadingRencanaMingguan} style={{
              ...btnStyle("#0d2129", loadingRencanaMingguan?C.muted:C.teal, loadingRencanaMingguan?C.border:"#1a4a4a"),
              width:"100%", padding:"10px 0", marginBottom:16,
            }}>
              {loadingRencanaMingguan ? "⏳ Memuat..." : "📅 Muat dari Rencana Mingguan"}
            </button>

            {/* Draft list dropdown */}
            {draftList.length > 0 && (
              <div style={{ background:"#0a1520", border:`1px solid #1a3040`, borderRadius:8, padding:"10px 12px", marginBottom:16 }}>
                <label style={{ fontSize:11, color:C.teal, fontWeight:700, display:"block", marginBottom:6 }}>📋 Muat Draft Tersimpan</label>
                <select
                  defaultValue=""
                  onChange={e => { if (e.target.value) loadDraftTanggal(e.target.value); }}
                  style={{ ...inp, fontSize:13 }}>
                  <option value="" disabled>Pilih tanggal draft...</option>
                  {draftList.map(d => (
                    <option key={d.tanggal} value={d.tanggal}>{formatTanggal(d.tanggal)}</option>
                  ))}
                </select>
              </div>
            )}

            <div style={{ marginBottom:20 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                <h2 style={{ margin:0, color:C.blue, fontSize:14, fontWeight:800 }}>Internal ULTG Paser</h2>
                <button onClick={() => addItem(setInternal)} style={{ ...btnStyle("transparent", C.blue, C.blue), padding:"6px 12px", fontSize:12 }}>+ Tambah</button>
              </div>
              {internal.length === 0 && (
                <div style={{ textAlign:"center", color:C.subtle, padding:"20px 0", fontSize:12, border:`1px dashed ${C.border}`, borderRadius:10 }}>
                  Tap "+ Tambah" untuk mulai
                </div>
              )}
              {internal.map((item, idx) => (
                <ItemForm key={item.id} item={item} index={idx} accent={C.blue} isInternal={true}
                  onChange={v => updateItem(setInternal, item.id, v)}
                  onRemove={() => removeItem(setInternal, item.id)} />
              ))}
            </div>

            <div style={{ marginBottom:20 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                <h2 style={{ margin:0, color:C.violet, fontSize:14, fontWeight:800 }}>Eksternal ULTG Paser</h2>
                <button onClick={() => addItem(setEksternal)} style={{ ...btnStyle("transparent", C.violet, C.violet), padding:"6px 12px", fontSize:12 }}>+ Tambah</button>
              </div>
              {eksternal.length === 0 && (
                <div style={{ textAlign:"center", color:C.subtle, padding:"20px 0", fontSize:12, border:`1px dashed ${C.border}`, borderRadius:10 }}>
                  Tap "+ Tambah" untuk mulai
                </div>
              )}
              {eksternal.map((item, idx) => (
                <ItemForm key={item.id} item={item} index={idx} accent={C.violet} isInternal={false}
                  onChange={v => updateItem(setEksternal, item.id, v)}
                  onRemove={() => removeItem(setEksternal, item.id)} />
              ))}
            </div>

            <button onClick={handleGenerate} disabled={loadingGenerate} style={{
              width:"100%", background: loadingGenerate ? C.subtle : `linear-gradient(135deg,${C.amber},#d97706)`,
              border:"none", color:C.bg, borderRadius:12, padding:"15px 0",
              fontSize:15, fontWeight:800, cursor: loadingGenerate ? "default" : "pointer",
              boxShadow: loadingGenerate ? "none" : "0 4px 16px rgba(245,158,11,0.3)",
            }}>
              {loadingGenerate ? "⏳ Menyimpan..." : "Generate Laporan Malam & Sore"}
            </button>
          </>
        )}

        {tab === "pagi" && (
          <div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
              <div>
                <div style={{ fontWeight:700, fontSize:14 }}>Laporan Malam</div>
                <div style={{ fontSize:11, color:C.muted }}>Kirim sebelum pekerjaan dimulai</div>
              </div>
              <button onClick={() => handleCopy(outputPagi, "pagi")} style={{
                ...btnStyle(copied==="pagi"?"#052e16":"#0f2744", copied==="pagi"?C.green:C.blue, copied==="pagi"?C.green:C.blue),
                padding:"10px 18px",
              }}>
                {copied==="pagi" ? "Tersalin!" : "1. Copy WA"}
              </button>
            </div>
            <div style={{ background:"#060d18", border:`1px solid ${C.border}`, borderRadius:10, padding:16, whiteSpace:"pre-wrap", fontFamily:"monospace", fontSize:12, lineHeight:1.8, color:"#d1fae5", marginBottom:14 }}>
              {outputPagi || <span style={{ color:C.subtle }}>Belum ada output. Kembali ke Input dan Generate.</span>}
            </div>
            {(() => {
              const semuaFile = [...internal, ...eksternal].flatMap(i => i.wpJsaFiles || []);
              const unik = Array.from(new Map(semuaFile.map(f => [f.id, f])).values());
              if (unik.length === 0) return null;
              const siap = filePdfSiap.length === unik.length && filePdfSiap.length > 0;
              return (
                <button disabled={!siap} onClick={() => {
                  if (!navigator.share || !navigator.canShare || !navigator.canShare({ files: filePdfSiap })) {
                    alert("Perangkat/browser ini belum bisa share file langsung. Coba dari HP dengan Chrome/Safari terbaru.");
                    return;
                  }
                  catatStat("kirim_pdf_wa", `${filePdfSiap.length} dokumen`);
                  navigator.share({ files: filePdfSiap, title: "Dokumen WP JSA" }).catch(e => {
                    if (e.name !== "AbortError") alert("Gagal share: " + e.message);
                  });
                }} style={{ ...btnStyle("#0f2744", siap?C.blue:C.subtle, siap?C.blue:C.subtle), width:"100%", padding:"10px 0" }}>
                  {siap ? `📤 2. Kirim Semua PDF (${filePdfSiap.length} dokumen)` : "⏳ Menyiapkan file..."}
                </button>
              );
            })()}
          </div>
        )}

        {tab === "sore" && (
          <div>
            <div style={{ background:C.panel, border:`1px solid ${C.border}`, borderRadius:10, padding:14, marginBottom:14 }}>
              <div style={{ color:C.amber, fontWeight:700, fontSize:13, marginBottom:12 }}>Update Progress</div>
              {[...internal.map(i=>({...i,_sec:"internal"})), ...eksternal.map(i=>({...i,_sec:"eksternal"}))].map(item => (
                <div key={item.id} style={{ background:C.bg, border:`1px solid ${C.border}`, borderRadius:8, padding:"10px 12px", marginBottom:8 }}>
                  <div style={{ fontSize:12, color:C.text, fontWeight:600, marginBottom:4 }}>{item.pekerjaan||"-"}</div>
                  <div style={{ fontSize:10, color:C.muted, marginBottom:8 }}>{item.lokasi}</div>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 80px", gap:8 }}>
                    <select value={item.progress}
                      onChange={e => {
                        const nilaiBaru = e.target.value;
                        const perubahan = nilaiBaru === "selesai" ? { progress: nilaiBaru, progressPersen: "100" } : { progress: nilaiBaru };
                        if (item._sec==="internal") updateItem(setInternal, item.id, {...item, ...perubahan});
                        else updateItem(setEksternal, item.id, {...item, ...perubahan});
                      }}
                      style={{ ...inp, fontSize:12, padding:"8px 10px" }}>
                      {PROGRESS_OPTIONS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                    </select>
                    <input type="number" min="0" max="100" inputMode="numeric"
                      value={item.progressPersen}
                      onChange={e => {
                        if (item._sec==="internal") updateItem(setInternal, item.id, {...item, progressPersen:e.target.value});
                        else updateItem(setEksternal, item.id, {...item, progressPersen:e.target.value});
                      }}
                      placeholder="%" style={{ ...inp, fontSize:12, padding:"8px 10px" }} />
                  </div>
                </div>
              ))}
              <button onClick={async () => {
                  setOutputSore(buildOutput(tanggal, internal, eksternal, "sore"));
                  await simpanHistory(tanggal, internal, eksternal, "sore");
                  await simpanDraft(tanggal, internal, eksternal);
                }}
                style={{ ...btnStyle("#0f2744", C.blue, C.blue), width:"100%", marginTop:8, padding:"10px 0" }}>
                Refresh Preview
              </button>
            </div>

            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
              <div>
                <div style={{ fontWeight:700, fontSize:14 }}>Laporan Sore</div>
                <div style={{ fontSize:11, color:C.muted }}>Update progress lalu Refresh</div>
              </div>
              <button onClick={() => handleCopy(outputSore, "sore")} style={{
                ...btnStyle(copied==="sore"?"#052e16":"#0f2744", copied==="sore"?C.green:C.blue, copied==="sore"?C.green:C.blue),
                padding:"10px 18px",
              }}>
                {copied==="sore" ? "Tersalin!" : "Copy WA"}
              </button>
            </div>
            <div style={{ background:"#060d18", border:`1px solid ${C.border}`, borderRadius:10, padding:16, whiteSpace:"pre-wrap", fontFamily:"monospace", fontSize:12, lineHeight:1.8, color:"#d1fae5" }}>
              {outputSore || <span style={{ color:C.subtle }}>Belum ada output.</span>}
            </div>
          </div>
        )}

        {tab === "history" && <TabHistory />}
        {tab === "kelola" && <TabKelolaDB />}
        {tab === "wpjsa" && <TabWpJsa />}
        {tab === "statistik" && <TabStatistik />}
        {tab === "rencanamingguan" && <TabRencanaMingguan />}
      </div>
    </div>
  );
}
